import { render, staticRenderFns } from "./CouplesReadingEn.vue?vue&type=template&id=d06b9770&lang=pug&"
import script from "./CouplesReadingEn.vue?vue&type=script&lang=js&"
export * from "./CouplesReadingEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports